import { Middleware } from 'redux';

const middleware: Middleware[] = [
  // yourMiddleware,
  // array of middleware you want to apply
];

export default middleware;
